import { ConfiguratorNavigationService } from '@obo-main/services/configurator/configuratorNavigation.service';
import { StateDeclaration, Transition, TransitionService } from '@uirouter/core';

export function configuratorNavigationHook(transitionService: TransitionService) {
    const configuratorNavigationCriteria = {
        to: (state: any) => true
    };

    const action = (transition: Transition, state: StateDeclaration) => {
        const configuratorNavigationService = transition.injector().get(ConfiguratorNavigationService) as ConfiguratorNavigationService;
        let triggerNext = state.data?.showConfiguratorNavigation;
        configuratorNavigationService.isActive.next(triggerNext);
        configuratorNavigationService.saveButtonTemplate.next(undefined);
        configuratorNavigationService.additionalButtonTemplate.next(undefined);
    };

    transitionService.onEnter(configuratorNavigationCriteria, action, {
        priority: 55
    });
}
